import Vue from 'vue'
import Vuex from 'vuex'

import testStudioSorting from '../modules/testStudioSorting';
import studioIsFiltered from '../modules/studioIsFiltered.js';

import getEmptyUserRequestSetupData from '../modules/getEmptyUserRequestSetupData';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    searchBarRenderKey: 0,
    user: null,
    testTypes: null,
    features: null,
    requestSetupConfig: null,
    searchParams: { "testType": 2, "countries": [], "features": [] },
    currentModal: null,
    bingAccepted: false,
    cities: null,
    countries: null,
    continents: null,
    testStudios: {
      details: false,
      items: []
    },
    dataLoaded: false,
    getBackendDataRetries: 0,
    // which test studio id to scroll to and open details (set via notification click)
    openDetailsTestStudioId: null
  },
  getters: {
    // list of notification objects to display in navbar
    notifications(state) {

      // notifications for new reviews
      const allReviews = state.testStudios.items.flatMap(studio => studio.reviews || []);
      console.log("allReviews", allReviews);
      const reviewsInCheckState = allReviews.filter(review => review.state == 0);
      let notifications = [];

      // Map reviews to notification objects
      notifications = reviewsInCheckState.map(review => {
        
        const testStudioId = review.testStudioId;
        const testStudioName = state.testStudios.items.find(studio => studio.id === testStudioId)?.displayName || "Unknown Studio";

        return {
          type: "review",
          icon: null,
          id: review.id,
          testStudioId: review.testStudioId,
          createdBy: review.createdBy,
          title: `${review.createdBy} added new review for ${testStudioName}`,
          message: ``,
          date: new Date(review.updatedAt),
          testStudioName: testStudioName
        };
      });

      return notifications;
    },
    requestListCustomLocations(state) {
      return state.user?.requestList?.customLocations;
    },
    searchBarRenderKey(state) {
      return state.searchBarRenderKey;
    },
    user(state) {
      return state.user;
    },
    requestSetupGeneralInfo: (state) => (name) => {
      return state.user.requestSetupData.generalInfo[name];
    },
    requestSetupSpecificInfo: (state) => (category, name) => {
      return state.user.requestSetupData.specificInfo[category][name];
    },
    requestSetupSpecificInfoDeep1: (state) => (category, level1, name) => {
      return state.user.requestSetupData.specificInfo[category][level1][name];
    },
    filteredAndSortedTestStudios(state) {

      let studios = state.testStudios.items.filter(el => !studioIsFiltered(state.searchParams, el));
      testStudioSorting.sortTestStudios(state.user, studios, state.searchParams.features);

      return {
        details: state.testStudios.details,
        items: studios
      };

    },
    myRequestListTestStudios(state) {
      return {
        details: true,
        items: state.testStudios.items.filter(x => state.user.requestList.testStudioIds.includes(x.id))
      }
    }
  },
  mutations: {
    // set test studio id to scroll to and open details via notification click
    setOpenDetailsTestStudioId(state, id) {
      state.openDetailsTestStudioId = id;
    },
    // clear after navigation and detail open
    clearOpenDetailsTestStudioId(state) {
      state.openDetailsTestStudioId = null;
    },

    setRequestListTestType(state, { testType }) {
      if (state.user.requestList) {
        state.user.requestList.testType = testType;
      }
    },

    increaseSearchBarRenderKey(state) {
      state.searchBarRenderKey++;
    },

    setRequestInputData(state, { requestInputJsonRaw }) {

      let parsedInput;

      try {
        parsedInput = JSON.parse(requestInputJsonRaw);
      } catch {
        console.log("could not parse requestInputData");
        return;
      }

      // Validierung

      // testType gleich
      if (parsedInput.generalInfo.testType != state.user.requestList.testType) {
        console.log("requestInput testType not matching requestList testType");
        return;
      }

      let userTestStudioIdsCopy = [...state.user.requestList.testStudioIds];
      userTestStudioIdsCopy.sort();

      // testStudioIds gleich
      if (JSON.stringify(parsedInput.generalInfo.testStudioIds.sort()) != JSON.stringify(userTestStudioIdsCopy)) {
        console.log("requestInput testStudioIds not matching requestList testStudioIds");
        return;
      }

      // dates müssen noch geparst werden
      if (parsedInput.specificInfo.timing.startDate) {
        parsedInput.specificInfo.timing.startDate = new Date(parsedInput.specificInfo.timing.startDate);
      }
      if (parsedInput.specificInfo.timing.endDate) {
        parsedInput.specificInfo.timing.endDate = new Date(parsedInput.specificInfo.timing.endDate);
      }

      state.user.requestSetupData = parsedInput;

    },
    acceptBingMaps(state) {
      state.bingAccepted = true;
    },
    setRequestSetupObjects(state, { generalInfo, specificInfo }) {
      state.user.requestSetupData = { generalInfo, specificInfo };
    },
    setRequestSetupDataGeneral(state, { name, value }) {
      Vue.set(state.user.requestSetupData.generalInfo, name, value);
    },
    setRequestSetupDataSpecific(state, { category, name, value }) {
      Vue.set(state.user.requestSetupData.specificInfo[category], name, value);
    },
    setRequestSetupDataSpecificDeep1(state, { category, level1, name, value }) {
      let subObj = {};
      subObj = Object.assign(subObj, state.user.requestSetupData.specificInfo[category][level1]);
      subObj[name] = value;
      Vue.set(state.user.requestSetupData.specificInfo[category], level1, subObj);
    },
    resetRequestSetupDataSpecific(state, { category }) {
      state.user.requestSetupData.specificInfo[category] = new Object();
    },
    clearRequestList(state) {
      state.user.requestList = {
        testStudioIds: [],
        customLocations: [],
        testType: null
      };
    },
    clearCurrentModal(state) {
      state.currentModal = null;
    },
    setCurrentModal(state, newModal) {
      if (!state.dataLoaded && !newModal.options.force) {
        return
      }
      state.currentModal = newModal;
    },
    clearSearch(state, proxyTestType) {
      let testType;
      if (state.user && state.user.requestList.testType) {
        testType = state.user.requestList.testType
      } else {
        testType = proxyTestType
      }
      state.searchParams = { testType: testType, countries: [], features: [] };
    },
    setSearchParams(state, params) {
      state.searchParams = params;
    },
    toggleSearchFeature(state, featureId) {
      if (state.searchParams.features.includes(featureId)) {
        state.searchParams.features = state.searchParams.features.filter(x => x != featureId);
      } else {
        state.searchParams.features.push(featureId);
      }
    },
    toggleSearchCountry(state, id) {
      if (state.searchParams.countries.includes(id)) {
        state.searchParams.countries = state.searchParams.countries.filter(el => el != id);
      } else {
        state.searchParams.countries.push(id);
      }
    },
    setBackendData(state, backendData) {
      // console.log(backendData);

      if (backendData.user) {
        state.user = backendData.user;
      }

      state.testTypes = backendData.testTypes;
      state.features = backendData.features;
      state.testStudios = backendData.testStudios;
      state.cities = backendData.cities;
      state.countries = backendData.countries;
      state.continents = backendData.continents;
      state.registrationFormInfo = backendData.registrationFormInfo;
      state.requestSetupConfig = backendData.requestSetupConfig;
      state.requestInputVersion = parseInt(backendData.requestInputVersion);
      state.dataLoaded = true;
    },
    loginUser(state, { user, testStudios, continents, countries, cities }) {
      state.user = user;
      if (user.bingMapsAgreed) {
        state.bingAccepted = true;
      } else {
        state.bingAccepted = false;
      }
      state.testStudios = testStudios;

      cities.sort((a, b) => {
        return testStudioSorting.getCityOrder(a, b);
      });

      state.continents = continents;
      state.cities = cities;
      state.countries = countries;
    },
    addCustomLocationToRequestList(state, { customLocation }) {
      state.user.requestList.customLocations.push(customLocation);
    },
    addTestStudioToRequestList(state, { testStudioId }) {
      state.user.requestList.testStudioIds.push(testStudioId);
    },
    removeCustomLocationFromRequestList(state, { customLocationId }) {
      if (!state.user) return;
      state.user.requestList.customLocations = state.user.requestList.customLocations.filter(el => el.id != customLocationId);
    },
    removeTestStudioFromRequestList(state, { testStudioId }) {
      state.user.requestList.testStudioIds = state.user.requestList.testStudioIds.filter(x => x !== testStudioId);
      if (state.user.requestList.testStudioIds.length === 0 && state.user.requestList.customLocations.length === 0) {
        state.user.requestList.testType = null;
      }
    },
    logoutUser(state) {
      state.user = null;
      state.bingAccepted = null;
    }
  },
  actions: {

    logoutUser({ commit }, $http) {
      return new Promise((resolve) => {

        $http({
          method: 'post',
          url: '/api/UserAction/Logout'
        }).then(() => {
          commit("logoutUser");
          return resolve();
        }).catch((e) => {
          console.log(e);
        });

      });
    },

    testStudioToggleRequestListStatus({ commit, state }, { testStudioId, $http }) {

      return new Promise((resolve, reject) => {
        let testStudio = state.testStudios.items.find(x => x.id == testStudioId);

        if (!state.user)
          return
        if (!state.user.requestList.testStudioIds.includes(testStudioId)) {
          if (state.user.requestList.testStudioIds.length === 0) {
            state.user.requestList.testType = state.searchParams.testType;
          } else if (!testStudio.testTypes.includes(state.user.requestList.testType)) {
            return;
          }

          $http({
            method: 'post',
            url: '/api/UserAction/AddRequestListItem',
            data: {
              testType: state.user.requestList.testType,
              testStudioId: testStudioId
            }
          })
            .then((rsp) => {
              if (rsp.data == "missing_overwrite_request_flag") {
                commit("setCurrentModal", {
                  type: "OverwriteRequestModal",
                  options: {
                    testType: state.user.requestList.testType,
                    testStudioId: testStudioId,
                    type: "add"
                  }
                });
                return;
              }
              commit('addTestStudioToRequestList', { testStudioId });
              return resolve();
            })
            .catch((err) => {
              return reject(err.response.data);
            });

        } else {

          $http({
            method: 'post',
            url: '/api/UserAction/RemoveRequestListItem',
            data: {
              testStudioId: testStudioId
            }
          })
            .then((rsp) => {
              if (rsp.data == "missing_overwrite_request_flag") {
                commit("setCurrentModal", {
                  type: "OverwriteRequestModal",
                  options: {
                    testType: state.user.requestList.testType,
                    testStudioId: testStudioId,
                    type: "remove"
                  }
                });
                return;
              }
              commit('removeTestStudioFromRequestList', { testStudioId });
              return resolve();
            })
            .catch((err) => {
              return reject(err.response.data);
            });

        }
      });

    },

    getBackendData({ dispatch, commit, state }, $http) {

      $http({
        method: 'post',
        url: '/api/AppData/InitialData'
      }).then(resp => {

        let data = resp.data;
        let backendData = {};

        if (data.user) {
          window.gtag("event", "login", {
            event_category: "login",
            method: "automatic",
          });
          backendData.user = data.user;
          backendData.user.requestSetupData = getEmptyUserRequestSetupData(data.user.requestList.testStudioIds, data.user.requestList.testType);
          if (data.user.requestList.testType) {
            commit("setSearchParams", { testType: data.user.requestList.testType, "countries": this.state.searchParams.countries, "features": this.state.searchParams.features });
          }
          if (data.user.bingMapsAgreed) {
            state.bingAccepted = true;
          } else {
            state.bingAccepted = false;
          }
        }

        data.cities.sort((a, b) => {
          return testStudioSorting.getCityOrder(a, b);
        });

        backendData.testTypes = data.testTypes;
        backendData.features = data.features;
        backendData.testStudios = data.testStudios;
        backendData.cities = data.cities;
        backendData.countries = data.countries;
        backendData.continents = data.continents;
        backendData.registrationFormInfo = data.registrationFormInfo;
        backendData.requestSetupConfig = data.requestSetupConfig;

        backendData.requestInputVersion = data.requestInputVersion;

        commit('setBackendData', backendData);
        if (data.user && data.user.requestInputJsonRaw && data.user.requestInputVersion && data.requestInputVersion == data.user.requestInputVersion) {
          commit("setRequestInputData", { requestInputJsonRaw: data.user.requestInputJsonRaw });
        }

      }).catch(err => {
        console.log(err);
        state.getBackendDataRetries += 1;
        if (state.getBackendDataRetries < 4) {
          setTimeout(() => {
            dispatch("getBackendData", $http);
          }, 1000);
        } else {
          console.log("Could not get backend data");
          commit("setCurrentModal", {
            type: "GeneralInfoModal",
            options: {
              title: "Information",
              content: "Unfortunately, our service could not be loaded. Please visit us later, again.",
              force: true
            }
          });
        }

      });

    },
    loginUser({ commit, state }, { email, password, $http }) {

      return new Promise((resolve, reject) => {
        $http({
          method: 'post',
          url: '/api/UserAction/Login',
          data: {
            email,
            password
          }
        })
          .then(data => {

            let user = {
              ...data.data.user,
              requestSetupData: getEmptyUserRequestSetupData(data.data.user.requestList.testStudioIds, data.data.user.requestList.testType)
            };

            let testStudios = data.data.testStudios;
            let cities = data.data.cities;
            let continents = data.data.continents;
            let countries = data.data.countries;

            commit('loginUser', { user, testStudios, cities, countries, continents });

            if (user.requestList.testType) {
              commit("setSearchParams", { testType: user.requestList.testType, "countries": this.state.searchParams.countries, "features": this.state.searchParams.features });
            }

            if (user.requestInputJsonRaw && user.requestInputVersion && state.requestInputVersion == user.requestInputVersion) {
              commit("setRequestInputData", { requestInputJsonRaw: user.requestInputJsonRaw });
            }

            return resolve();
          })
          .catch(err => {
            if (err.response) {
              return reject(err.response.data);
            } else {
              return reject(err);
            }
          });
      });



    },
    clearRequestList({ commit }, $http) {
      return new Promise((resolve, reject) => {

        $http({
          method: 'post',
          url: '/api/UserAction/ClearRequestList'
        })
          .then(() => {
            commit('clearRequestList');
            return resolve();
          })
          .catch((err) => {
            return reject(err.response.data);
          });

      });
    }
  },
  modules: {
  }
})
